// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eth-amount {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.eth-value {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
}

.eth-logo {
  width: 16px;
  height: 16px;
  display: inline-block;
}

.eth-value .amount {
  font-size: 16px;
  color: #111827;
}

.usd-value {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  margin-left: 24px; /* Align with ETH text, accounting for icon */
}

.loading {
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
  margin-left: 24px;
}

.error {
  font-size: 12px;
  color: #ef4444;
  font-style: italic;
  margin-left: 24px;
}

/* Compact version for tables */
.eth-amount.compact {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.eth-amount.compact .usd-value {
  margin-left: 0;
  font-size: 12px;
}

.eth-amount.compact .loading,
.eth-amount.compact .error {
  margin-left: 0;
  font-size: 11px;
}

/* Card version */
.eth-amount.card {
  align-items: flex-start;
}

.eth-amount.card .eth-value {
  font-size: 18px;
  font-weight: 600;
}

.eth-amount.card .usd-value {
  font-size: 16px;
  color: #374151;
  margin-left: 0;
}

.eth-amount.card .loading,
.eth-amount.card .error {
  font-size: 14px;
  margin-left: 0;
}


`, "",{"version":3,"sources":["webpack://./src/components/EthAmount.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB,EAAE,6CAA6C;AAClE;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".eth-amount {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.eth-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n}\n\n.eth-logo {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\n\n.eth-value .amount {\n  font-size: 16px;\n  color: #111827;\n}\n\n.usd-value {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 400;\n  margin-left: 24px; /* Align with ETH text, accounting for icon */\n}\n\n.loading {\n  font-size: 12px;\n  color: #9ca3af;\n  font-style: italic;\n  margin-left: 24px;\n}\n\n.error {\n  font-size: 12px;\n  color: #ef4444;\n  font-style: italic;\n  margin-left: 24px;\n}\n\n/* Compact version for tables */\n.eth-amount.compact {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.eth-amount.compact .usd-value {\n  margin-left: 0;\n  font-size: 12px;\n}\n\n.eth-amount.compact .loading,\n.eth-amount.compact .error {\n  margin-left: 0;\n  font-size: 11px;\n}\n\n/* Card version */\n.eth-amount.card {\n  align-items: flex-start;\n}\n\n.eth-amount.card .eth-value {\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.eth-amount.card .usd-value {\n  font-size: 16px;\n  color: #374151;\n  margin-left: 0;\n}\n\n.eth-amount.card .loading,\n.eth-amount.card .error {\n  font-size: 14px;\n  margin-left: 0;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
